export default __webpack_public_path__ + "static/paxton-house-93b049a6c0e39d993eda05e271a96579.jpg";